import React, { useState, useEffect, useContext } from "react";
import { Table, Button, Row, Col } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import { MdPreview } from "react-icons/md";
import PreviewFeeInstallment from "./PreviewFeeInstallment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";

function Fees(props) {
  const [studentInstallments, setStudentInstallments] = useState([]);
  const { selectedSessionId } = useContext(SessionContext);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [pendingDueDay, setPendingDueDay] = useState("");
  const handlePreviewClick = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const resolveAdmissionId = () => {
    if (props?.studenId && typeof props.studenId === "object") {
      return (
        props.studenId.student_addmission_id ||
        props.studenId.addmission_id ||
        props.studenId.id
      );
    }

    return props?.student_addmission_id || props?.studenId || props?.id;
  };

  const header1 = [
    {
      title: "Month",
      prop: "month",
      isFilterable: true,
    },
    {
      title: "Installment Amt",
      prop: "total_inst_amt",
    },
    {
      title: "Other Amt",
      prop: "other_amount",
    },
    {
      title: "Deposited amt",
      prop: "deposit_amount",
      isFilterable: true,
      cell: (row) => (row.deposit_amount ? row.deposit_amount : 0),
    },
    // {
    //   title: "Due Date",
    //   prop: "due_date",
    //   isFilterable: true,
    //   cell: (row) => formatDate(row.due_date),
    // },
    {
      title: "Due Date",
      prop: "due_date",
      isFilterable: true,
      cell: (row) => {
        const date = new Date(row.due_date);
        date.setDate(Number(pendingDueDay));
        return formatDate(date);
      },
    },
    {
      title: "Status",
      prop: "status",
      cell: (row) => (row.status === "completed" ? "Completed" : "Pending"),
    },
    {
      title: "Preview",
      prop: "",
      isFilterable: true,
      cell: (row) => (
        <Button title="Preview" onClick={() => handlePreviewClick(row)}>
          <MdPreview />
        </Button>
      ),
    },
  ];

  useEffect(() => {
    fetchInstallments();
  }, [props?.studenId, selectedSessionId]);

  const fetchInstallments = async () => {
    const admissionId = resolveAdmissionId();

    console.log("Fees props:", props);
    console.log("Resolved admissionId:", admissionId);

    if (!admissionId || admissionId === "undefined") {
      setStudentInstallments([]);
      return;
    }

    try {
      const result = await schoolApi.fetchStudentFeeInstallments(admissionId);
      const settingsResult = await schoolApi.getAllSetting()

      console.log("settingresult", settingsResult)
      // Agar settingsResult.result me data hai
      const pendingDueDay = settingsResult?.data?.find(
        (item) => item.key === "pending_due_day"
      )?.value;

      setPendingDueDay(pendingDueDay);
      console.log("Pending Due Day:", pendingDueDay);

      console.log("result-->", result)

      if (result?.success) {
        setStudentInstallments(result.result || []);
      } else {
        setStudentInstallments([]);
      }
    } catch (error) {
      console.error("Error fetching installments:", error);
      setStudentInstallments([]);
      toast.error(error?.response?.data?.message || error.message);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Row className="mt-4 mb-3">
        <Col className="mx-3">
          <DatatableWrapper body={studentInstallments} headers={header1}>
            <Table striped className="data-table">
              <TableHeader />
              <TableBody />
            </Table>
          </DatatableWrapper>
          {studentInstallments.length === 0 && (
            <div className="text-center py-3">No fee records found</div>
          )}
        </Col>

        {showModal && (
          <PreviewFeeInstallment
            row={selectedRow}
            showModal={showModal}
            setShowModal={setShowModal}
          />
        )}
      </Row>
    </div>
  );
}

export default Fees;
